import { MoneyIcon } from "assets/icons";
import { DropdownSetting, InformationSetting } from "components/settings";
import { WidgetType } from "types/Widget";

import Money from "./Money";
import MoneySetting from "./MoneySetting";

export const MoneyWidget: WidgetType = {
  name: "Money",
  component: Money,
  icon: MoneyIcon,
  showOnToolbar: true,
  sizing: {
    minWidth: 400,
    minHeight: 245,
    minAspectRatio: 0.5,
    maxAspectRatio: 1.75,
  },
  defaultState: {
    currency: "AUD",
    limitValue: 0,
  },
  defaultSize: {
    aspectRatio: 2,
    widthPercentage: 50,
  },
  settings: {
    header: {
      editor: InformationSetting,
      info: {
        info: "Use the Money tool to practice handling money. Drag and drop coins and bills to make payments, calculate totals, and determine the correct change.",
      },
    },
    currency: {
      defaultValue: "AUD",
      editor: DropdownSetting,
      info: {
        name: "Choose currency",
        options: ["AUD", "NZD", "GBP", "USD"],
      },
    },
    format: {
      editor: DropdownSetting,
      info: {
        name: "Grid",
        options: ["1", "2", "3", "4"],
      },
      defaultValue: "1",
    },
    type: {
      editor: DropdownSetting,
      info: {
        name: "Money",
        options: ["Coin & Notes", "Coin", "Note"],
      },
      defaultValue: "Coin & Notes",
    },
    config: {
      defaultValue: {
        currency: "AUD",
        target: 0,
        theme: "money_lab",
        range: 0,
      },
      editor: MoneySetting,
      info: {
        limit: { label: "Target", theme_label: "Theme", range: "Range" },
      },
    },
  },
  quickActions: {},
};
